import { gql } from "@apollo/client";
import { Box, Stack } from "@chakra-ui/react";
import { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

import { PageTitle } from "../../components/Page";
import { Panel } from "../../components/Panel";
import { SupplierAddressForm } from "../../components/SupplierAddressForm";
import { buildAddressPagePath, RouteParams } from "../../config/routes";
import { useCreateSupplierAddressMutation } from "../../generated/graphql";
import { useSingleParam } from "../../hooks/useSingleParam";

export const ADDRESS_CREATION_CREATE_SUPPLIER_ADDRESS = gql`
  mutation CreateSupplierAddress($input: CreateSupplierAddressInput!) {
    createSupplierAddress(input: $input) {
      id
    }
  }
`;

export const AddressCreationPage = () => {
  const navigate = useNavigate();
  const supplierSlug = useSingleParam(RouteParams.SupplierSlug, { required: true });

  const [createSupplierAddress] = useCreateSupplierAddressMutation();

  return (
    <Fragment>
      <Helmet>
        <title>WMS | New Address</title>
      </Helmet>
      <Stack spacing={6} px={8} py={5}>
        <Stack width="100%" isInline justifyContent="space-between">
          <PageTitle>New Address</PageTitle>
        </Stack>

        <Panel maxWidth="900px">
          <Box px={8} py={5}>
            <SupplierAddressForm
              onSubmit={async (values) => {
                const { data } = await createSupplierAddress({
                  variables: {
                    input: {
                      ...values,
                      supplierSlug,
                    },
                  },
                });

                if (data?.createSupplierAddress?.id) {
                  navigate(buildAddressPagePath(supplierSlug, data.createSupplierAddress.id));
                  return;
                }

                console.log("TODO: handle this");
              }}
            />
          </Box>
        </Panel>
      </Stack>
    </Fragment>
  );
};
